// extracted by mini-css-extract-plugin
export default {"contactContainer":"ContactPage_contactContainer__Fa49y","socialLinksContainer":"ContactPage_socialLinksContainer__Y0bEn","iconLink":"ContactPage_iconLink__mUYxh"};